import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { router } from "./app/router";
import { SessionProvider } from "./context/SessionContext";
import { OrderDraftProvider } from "./context/OrderDraftContext";
import { AppToaster } from "./components/ui";
import { PATHS } from "./app/paths";
import { initMonitoring } from "./lib/monitoring";

initMonitoring();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const onRedirectCallback = (appState?: AppState) => {
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  );
};

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="login.letsdoc.ai"
      clientId="ohM1vmzZiS1FyJRsxmDHRREjbifWjUzZ"
      authorizationParams={{
        redirect_uri: window.location.origin + PATHS.authCallback,
      }}
      onRedirectCallback={onRedirectCallback}
      // Token só na memória em produção: um script de terceiros (GTM) não acha nada gravado. Ao recarregar,
      // o Auth0 renova sem pedir login porque app.letsdoc.ai e login.letsdoc.ai são o mesmo site.
      // No localhost (outro site) o navegador pode bloquear isso, então lá continua no localStorage.
      cacheLocation={process.env.NODE_ENV === "development" ? "localstorage" : "memory"}
    >
      <SessionProvider>
        <OrderDraftProvider>
          <AppToaster />
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </OrderDraftProvider>
      </SessionProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
